var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2499 1.75015C12.5151 1.48493 12.8748 1.33594 13.2499 1.33594C13.625 1.33594 13.9847 1.48493 14.2499 1.75015C14.5151 2.01537 14.6641 2.37508 14.6641 2.75015C14.6641 3.12522 14.5151 3.48493 14.2499 3.75015L8.24123 9.75948C8.08293 9.91765 7.88737 10.0334 7.67257 10.0962L5.75723 10.6562C5.69987 10.6729 5.63906 10.6739 5.58117 10.6591C5.52329 10.6442 5.47045 10.6141 5.4282 10.5719C5.38594 10.5296 5.35583 10.4768 5.341 10.4189C5.32617 10.361 5.32717 10.3002 5.3439 10.2428L5.9039 8.32748C5.96692 8.11285 6.08292 7.91752 6.24123 7.75948L12.2499 1.75015Z",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEditIcon);
export default __webpack_public_path__ + "static/media/pencil-edit-icon.b0c4ec0eb4f5e019e4d41462b2891005.svg";
export { ForwardRef as ReactComponent };